import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=397606d5&"
import script from "./SystemMessage.vue?vue&type=script&lang=js&"
export * from "./SystemMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('397606d5')) {
      api.createRecord('397606d5', component.options)
    } else {
      api.reload('397606d5', component.options)
    }
    module.hot.accept("./SystemMessage.vue?vue&type=template&id=397606d5&", function () {
      api.rerender('397606d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/SystemMessage.vue"
export default component.exports